const UNKNOWN = 'unknown';

function getTimezone() {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof timezone === 'string' && timezone.trim() ? timezone : UNKNOWN;
  } catch {
    return UNKNOWN;
  }
}

function getLanguage() {
  try {
    const { language } = navigator;
    return typeof language === 'string' && language.trim() ? language : UNKNOWN;
  } catch {
    return UNKNOWN;
  }
}

export default function getBrowserSessionAttributes() {
  return {
    'browser.timezone': getTimezone(),
    'browser.language': getLanguage(),
  };
}
